import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useContasReceberListaFilters
 */

const getFirstDayOfMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
};

const getLastDayOfMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0);
};

type State = {
    idsCentroCusto?: number[];
    idsCliente?: number[];
    idsBanco?: number[];
    idsOrdemCompra?: number[];
    idsSubconta?: number[];
    status: number | null;
    titulo: string | null;
    nroConta: number | null;
    dataReceberDe: Date | null;
    dataReceberAte: Date | null;
    dataRecebidoDe: Date | null;
    dataRecebidoAte: Date | null;
    dataCriacaoDe: Date | null;
    dataCriacaoAte: Date | null;
    idContratoFinanceiro?: number | null;

};

type Action = {
    setFilters: (filters: Partial<State>) => void;
    clearFilters: () => void;
};

export const useContasReceberListaFilters = create<State & Action>((set) => ({
    idsCentroCusto: [],
    idsCliente: [],
    idsBanco: [],
    idsOrdemCompra: [],
    idsSubconta: [],
    status: 5,
    titulo: "",
    dataReceberDe: getFirstDayOfMonth(),
    dataReceberAte: getLastDayOfMonth(),
    dataRecebidoDe: null,
    dataRecebidoAte: null,
    dataCriacaoDe: null,
    dataCriacaoAte: null,
    idContratoFinanceiro: null,
    nroConta: null,
    setFilters: (filters) => set((state) => ({ ...state, ...filters })),
    clearFilters: () => set({ ...initialContasReceberFiltersValues }),

}));

export const initialContasReceberFiltersValues: State = {
    idsCentroCusto: [],
    idsCliente: [],
    idsBanco: [],
    idsOrdemCompra: [],
    idsSubconta: [],
    status: 5,
    titulo: "",
    nroConta: null,
    dataReceberDe: null,
    dataReceberAte: null,
    dataRecebidoDe: null,
    dataRecebidoAte: null,
    dataCriacaoDe: null,
    dataCriacaoAte: null,
    idContratoFinanceiro: null,

};